import React from 'react'

import {
  isContainerTargetType,
  isHostTargetType,
  isK8sTargetType
} from 'components/attacks/utils/attack-configuration'
import { TagsDisplay } from 'components/services/details/TagsDisplay'
import { TargetingStrategy } from 'types/api/attacks/details/targeting'

export const TargetingSection: React.FC<{
  targetingStrategy: TargetingStrategy
}> = ({ targetingStrategy }) => {
  if (isHostTargetType(targetingStrategy)) {
    return <TagsDisplay multiValueMap={targetingStrategy.multiSelectTags} />
  } else if (isContainerTargetType(targetingStrategy)) {
    return <TagsDisplay multiValueMap={targetingStrategy.multiSelectLabels} />
  } else if (isK8sTargetType(targetingStrategy)) {
    const objectMap = targetingStrategy.names?.reduce((objects, o) => {
      if (!Array.isArray(objects[o?.kind])) {
        objects[o.kind] = []
      }
      objects[o.kind].push(o.name)
      return objects
    }, {})
    return <TagsDisplay multiValueMap={objectMap} />
  }

  return null
}
